import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getAttrValue } from '@grandvisionhq/utils';
import { getActions } from './actions.js';
import { reducer } from './reducer.js';
import { getSelectors } from './selectors.js';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { mapToPrescriptionRanges } from './utils/map-to-prescription-ranges.js';
import { getInitialState } from './utils/get-initial-state.js';
import { triggerToastMessage } from './utils/trigger-toast-message.js';

const CLEcommContext = /*#__PURE__*/ React.createContext({});
const useCLEcommContext = ()=>React.useContext(CLEcommContext)
;
const CLEcommProvider = ({ children  })=>{
    const { activeVariant , product , clAndSolutionsMaxOrderableQuantity  } = useProductDetailContext();
    const { masterVariant , slug  } = product;
    const sortedAttributesSet = mapToPrescriptionRanges(masterVariant.opticalRanges);
    const brandKey = String(getAttrValue(masterVariant, 'brandKey'));
    if (!CommerceToolsApi.isLenses(activeVariant)) {
        return null;
    }
    if (!sortedAttributesSet || !sortedAttributesSet.length) {
        console.error(`Required prescription ranges not provided for Contact Lens`, {
            slug: slug === null || slug === void 0 ? void 0 : slug.en,
            sku: masterVariant.sku
        });
    }
    if (!!(sortedAttributesSet === null || sortedAttributesSet === void 0 ? void 0 : sortedAttributesSet.length) && !sortedAttributesSet.some((attr)=>attr.name === 'power'
    )) {
        console.error(`Required Power prescription range not provided for Contact Lens`, {
            slug: slug === null || slug === void 0 ? void 0 : slug.en,
            sku: masterVariant.sku
        });
    }
    const initialState = React.useMemo(()=>getInitialState({
            sortedAttributesSet,
            lensesPerBox: activeVariant.packageQuantity,
            maxOrderableQuantity: clAndSolutionsMaxOrderableQuantity
        })
    , []);
    const [state, dispatch] = React.useReducer(reducer, initialState);
    const actions = React.useMemo(()=>getActions(dispatch)
    , []);
    const selectors = React.useMemo(()=>getSelectors()
    , []);
    React.useDebugValue('CLEcommProvider');
    const value = {
        actions,
        state,
        selectors,
        sortedAttributesSet,
        brandKey,
        triggerToastMessage
    };
    return /*#__PURE__*/ React.createElement(CLEcommContext.Provider, {
        value: value
    }, children);
};

export { CLEcommContext, CLEcommProvider, useCLEcommContext };
//# sourceMappingURL=CLEcommContext.js.map
